var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDocument24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_document24x24",
    transform: "translate(1645.6 303.6)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46082",
    d: "M-1635.824-300.485V-303.6h-7.911a1.784,1.784,0,0,0-1.865,1.731v14.538a1.784,1.784,0,0,0,1.865,1.731h11.269a1.784,1.784,0,0,0,1.866-1.731v-11.146h-3.06a2.092,2.092,0,0,1-2.164-2.008Zm-5.522,5.815,2.985-2.977a.583.583,0,0,1,.3-.138.4.4,0,0,1,.3.138l2.985,2.977a.4.4,0,0,1,0,.554c-.074.069-.149.069-.3.069a.4.4,0,0,1-.3-.138l-2.313-2.285V-291a.414.414,0,0,1-.448.415q-.448,0-.448-.415v-5.469l-2.313,2.285a.477.477,0,0,1-.6.069.578.578,0,0,1,.149-.554Zm7.91,6.162c0,.208-.149.346-.448.346h-8.433a.34.34,0,0,1-.373-.346.4.4,0,0,1,.373-.415h8.433q.448.1.448.415Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46083",
    d: "M-1629.843-298.168h2.941l-4.5-4.532v3.021a1.528,1.528,0,0,0,1.557,1.511Z",
    transform: "translate(-3.699 -.9)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDocument24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_document24x24.949d4b7de81887253e30247783cd0746.svg";